/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControlLabel,
  Grid,
} from '@mui/material';
import useStyles from '../../../assets/styles/pages/ShopRequest';
import Header from '../../../components/Header';

// import svg
import { ReactComponent as IconPlus } from '../../../assets/images/svg/shops/request/button_mais.svg';
import { ReactComponent as IconLess } from '../../../assets/images/svg/shops/request/button_menos.svg';
import { ReactComponent as IconChecked } from '../../../assets/images/svg/shops/request/icon_check_ok.svg';
import { ReactComponent as IconCheck } from '../../../assets/images/svg/shops/request/icon_check.svg';
import { ReactComponent as IconArrowRight } from '../../../assets/images/svg/shops/request/icon_seta_direita.svg';

const RequestProduct: React.FC = () => {
  const classeStyle = useStyles();

  const [incrementQt, setIncrementQt] = useState<number>(0);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="DetailRequest" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        marginBottom="50px"
      >
        <Grid className={classeStyle.gridMain}>
          <h3>Escolha seu *</h3>
          <Grid>
            <Grid className={classeStyle.gridProduct}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<IconCheck />}
                    checkedIcon={<IconChecked />}
                    defaultChecked
                  />
                }
                label={
                  <>
                    <h5 className={classeStyle.titleProduct}>Produto</h5>
                    <p className={classeStyle.textDesProduct}>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Optio ad inventore numquam repellendus
                    </p>
                  </>
                }
              />
              <Grid className={classeStyle.gridVlQtProduct}>
                <p className={classeStyle.textVlProduct}>R$ 00,00</p>
                <Grid className={classeStyle.gridIncrementQtProduct}>
                  <IconPlus onClick={() => setIncrementQt(incrementQt + 1)} />
                  <p className={classeStyle.textQtProduct}>{incrementQt}</p>
                  <IconLess
                    onClick={() =>
                      setIncrementQt(incrementQt >= 1 ? incrementQt - 1 : 0)
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid className={classeStyle.gridProduct}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<IconCheck />}
                    checkedIcon={<IconChecked />}
                    defaultChecked
                  />
                }
                label={
                  <>
                    <h5 className={classeStyle.titleProduct}>Produto</h5>
                    <p className={classeStyle.textDesProduct}>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Optio ad inventore numquam repellendus
                    </p>
                  </>
                }
              />
              <Grid className={classeStyle.gridVlQtProduct}>
                <p className={classeStyle.textVlProduct}>R$ 00,00</p>
                <Grid className={classeStyle.gridIncrementQtProduct}>
                  <IconPlus onClick={() => setIncrementQt(incrementQt + 1)} />
                  <p className={classeStyle.textQtProduct}>{incrementQt}</p>
                  <IconLess
                    onClick={() =>
                      setIncrementQt(incrementQt >= 1 ? incrementQt - 1 : 0)
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid className={classeStyle.gridProduct}>
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<IconCheck />}
                    checkedIcon={<IconChecked />}
                  />
                }
                label={
                  <>
                    <h5 className={classeStyle.titleProduct}>Produto</h5>
                    <p className={classeStyle.textDesProduct}>
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Optio ad inventore numquam repellendus
                    </p>
                  </>
                }
              />
            </Grid>
          </Grid>
          <Button
            className={classeStyle.btnSubmit}
            type="submit"
            variant="contained"
          >
            <p className={classeStyle.textBtnSubmit}>Continuar</p>
            <IconArrowRight />
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestProduct;
